import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from './LinkedHashMap.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function eachCount(_this__u8e3s4) {
  // Inline function 'kotlin.collections.fold' call
  // Inline function 'kotlin.collections.aggregate' call
  // Inline function 'kotlin.collections.mutableMapOf' call
  // Inline function 'kotlin.collections.aggregateTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = _this__u8e3s4.sourceIterator_2zqxcn_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var e = _iterator__ex2g4s.next_20eer_k$();
    var key = _this__u8e3s4.keyOf_d1fr09_k$(e);
    var accumulator = destination.get_wei43m_k$(key);
    // Inline function 'kotlin.collections.set' call
    var value = (accumulator == null && !destination.containsKey_aw81wo_k$(key) ? 0 : accumulator) + 1 | 0;
    destination.put_4fpzoq_k$(key, value);
  }
  return destination;
}
//region block: exports
export {
  eachCount as eachCount1imd75z0wkpbt,
};
//endregion

//# sourceMappingURL=GroupingJs.mjs.map
